import { render, staticRenderFns } from "./yilvkeliang.vue?vue&type=template&id=2ef9a264&scoped=true&lang=pug"
import script from "./yilvkeliang.vue?vue&type=script&lang=ts"
export * from "./yilvkeliang.vue?vue&type=script&lang=ts"
import style0 from "./yilvkeliang.vue?vue&type=style&index=0&id=2ef9a264&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef9a264",
  null
  
)

export default component.exports